import React, { useState, useEffect } from "react";
import useCustomMutation from "../../../../Hooks/useCustomMutation";
import { Row, Col } from "reactstrap";
import ButtonSubmit from "../../../Buttons/ButtonSubmit";
import ProfilePicture from "../../../Profile/ProfilePicture";
import { countryList } from "../../../Countries/countries";
import { title } from "../../../Common/Title/Title";

import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

function AddSpeaker({ userId, eventID, token, setIsOffcanvasOpen }) {
  const [showImage, setShowImage] = useState(null);
  const [uploadImg, setUploadImg] = useState(null);
  const [inputs, setInputs] = useState({
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    jobTitle: "",
    organization: "",
    phoneNumber: "",
    city: "",
    country: "",
    speakerBiography: "",
  });
  const [phoneError, setPhoneError] = useState(null);
  
  const key = ["mySpeakers", eventID];
  const mutation = useCustomMutation(key);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handlePhoneChange = (value) => {
    setInputs({ ...inputs, phoneNumber: value });
    // Clear phone error when user enters a number
    if (value) {
      setPhoneError(null);
    }
  };

  const validatePhoneNumber = (phone) => {
    // Accept any valid international phone number
    // Minimum 7 digits, maximum 15 digits (E.164 standard)
    if (!phone) return "Phone number is required";
    
    // Remove all non-digit characters for validation
    const digits = phone.replace(/\D/g, '');
    
    if (digits.length < 7) {
      return "Phone number must be at least 7 digits";
    }
    if (digits.length > 15) {
      return "Phone number must not exceed 15 digits";
    }
    
    return null; // Valid
  };

  const toggleSaveChanges = (e) => {
    e.preventDefault();
    
    // Validate phone number
    const phoneValidationError = validatePhoneNumber(inputs.phoneNumber);
    if (phoneValidationError) {
      setPhoneError(phoneValidationError);
      return;
    }
    
    const Method = "POST",
      url = `speakers/${eventID}`,
      isJSON = true;
    const formdata = new FormData();
    
    if (uploadImg) {
      formdata.append("photo", uploadImg);
    }
    
    Object.entries(inputs).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        formdata.append(key, value);
      }
    });

    const data = {
      endPoint: url,
      bodyContent: formdata,
      Method: Method,
      displayMessage: "Speaker successfully invited",
      token: token,
      isJSON: isJSON,
    };
    
    mutation.mutate(data);
  };

  useEffect(() => {
    if (mutation?.isSuccess) {
      setIsOffcanvasOpen(false);
    }
  }, [mutation?.isSuccess]);

  return (
    <div className="w-100 d-flex justify-content-center p-3">
      <form
        noValidate
        autoComplete="off"
        data-testid="form"
        onSubmit={toggleSaveChanges}
      >
        <Row>
          <Col md={12}>
            <div className="d-flex mb-3 justify-content-center">
              <ProfilePicture
                showImage={showImage}
                setShowImage={setShowImage}
                setUploadImg={setUploadImg}
                iconSize={80}
                iconColor="#F68A20"
                imgHeight={80}
                imgWidth={80}
                imgBorder="50%"
              />
            </div>
          </Col>
          
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Title
            </label>
            <select
              name="title"
              value={inputs.title}
              onChange={handleChange}
              className="mb-3 form-control"
              style={{ borderRadius: 7 }}
              required
            >
              <option value="">Select...</option>
              {title?.map((titleItem, i) => (
                <option key={i} value={titleItem}>
                  {titleItem}
                </option>
              ))}
            </select>
          </Col>
          
          <Col md={6} lg={6}></Col>
          
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>First name
            </label>
            <input
              type="text"
              name="firstName"
              value={inputs?.firstName}
              placeholder="Enter First name"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Last name
            </label>
            <input
              type="text"
              name="lastName"
              value={inputs?.lastName}
              placeholder="Enter Last name"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Email
            </label>
            <input
              type="email"
              name="email"
              value={inputs?.email}
              placeholder="Enter email"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Job Title
            </label>
            <input
              type="text"
              name="jobTitle"
              value={inputs?.jobTitle}
              placeholder="Enter Job Title"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Organization Name
            </label>
            <input
              type="text"
              name="organization"
              value={inputs?.organization}
              placeholder="Enter organization name"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>Phone Number
            </label>
            <div className="phone-input-container">
              <PhoneInput
                international
                countryCallingCodeEditable={false}
                // Remove defaultCountry to allow any country
                // or set it based on user's location
                value={inputs.phoneNumber || null}
                onChange={handlePhoneChange}
                className="custom-phone-input"
                placeholder="Enter phone number"
              />
              {phoneError && (
                <div className="text-danger mt-1" style={{ fontSize: "12px" }}>
                  {phoneError}
                </div>
              )}
              <small className="text-muted" style={{ fontSize: "11px", display: "block", marginTop: "4px" }}>
                Accepts international numbers (e.g., +27, +263, +1, etc.)
              </small>
            </div>
          </Col>
          
          <Col md={6} lg={6}>
            <label>
              <span className="text-danger">*</span>City
            </label>
            <input
              type="text"
              name="city"
              value={inputs?.city}
              placeholder="Enter City"
              onChange={handleChange}
              style={{ borderRadius: 7 }}
              className="mb-3 form-control fromInput"
              required
            />
          </Col>
          
          <Col md={6} lg={6}>
            <label className="event__form__Creation">
              <span className="text-danger">*</span>Country
            </label>
            <select
              name="country"
              value={inputs.country}
              onChange={handleChange}
              className="mb-3 form-control"
              style={{ borderRadius: 7 }}
              required
            >
              <option value="">Select Country</option>
              {countryList?.map((country, i) => (
                <option key={i} value={country}>
                  {country}
                </option>
              ))}
            </select>
          </Col>
          
          <Col md={12} lg={12}>
            <label className="event__form__Creation">
              <span className="text-danger">*</span>Bio
            </label>
            <textarea
              name="speakerBiography"
              value={inputs.speakerBiography}
              onChange={handleChange}
              placeholder="Write speaker biography here..."
              className="mb-3 form-control fromInput"
              rows={5}
              required
            ></textarea>
          </Col>
          
          <div className="mb-3"></div>
          
          <div className="w-100 d-flex justify-content-center">
            <ButtonSubmit
              Title="Submit"
              ColorText="white"
              BorderColor="#F68A20"
              BackgroundColor="#F68A20"
              borderRadius="25px"
              handleOnclick={toggleSaveChanges}
              pending={mutation?.isLoading}
            />
          </div>
        </Row>
      </form>
    </div>
  );
}

export default AddSpeaker;